import {ApplicationRef, Component, ElementRef, Inject, InjectionToken, OnDestroy, Renderer2} from '@angular/core';
import {OverlayContainer} from "@angular/cdk/overlay";

export const SPINNER_TEXT_TOKEN = new InjectionToken<string>('text');
export const SPINNER_ELEMENT_TOKEN = new InjectionToken<ElementRef | null>('element');


@Component({
  selector: 'valg-spinner',
  templateUrl: './spinner.component.html',
  host: {
    class: 'valg-spinner',
    role: 'alert'
  }
})
export class SpinnerComponent implements OnDestroy{

  private root!: ElementRef;

  constructor(
    @Inject(SPINNER_TEXT_TOKEN) public text: string,
    private readonly renderer: Renderer2,
    private overlayContainer: OverlayContainer,
    private app:ApplicationRef) {
      this.root = this.app.components[0].location;
      this.renderer.setAttribute(this.root.nativeElement, 'aria-live', 'polite');
      this.renderer.setAttribute(this.root.nativeElement, 'aria-atomic', 'false');
      this.renderer.setAttribute(this.root.nativeElement, 'aria-busy', 'true');
      
      this.renderer.addClass(this.overlayContainer.getContainerElement(), 'spinner-overlay-container');
      this.renderer.addClass(document.body, 'spinner-active');
  }

  ngOnDestroy(){
    this.renderer.setAttribute(this.root.nativeElement, 'aria-busy', 'false');
    this.renderer.removeClass(this.overlayContainer.getContainerElement(), 'spinner-overlay-container');
    this.renderer.removeClass(document.body, 'spinner-active');

  }
}
